import React, { useEffect, useState } from 'react'
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast'
import $ from 'jquery';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from '../../../../../common/app_constant';
import ErrorLabel from "../../../../../component/error_label";
import { actionUploadClaimDoc, resetUploadClaimResponse } from '../store';


const UploadDocuments = (props) => {

    const dispatch = useDispatch()

    const { uploadClaimDoc } = useSelector((state) => ({
        ...state.claimStore
    }))


    const {
        register,
        formState: { errors },
        handleSubmit,
        setValue,
    } = useForm({
        defaultValues: {
            documents: null
        },
    });

    const [allDropdownArr, setAllDropdownArr] = useState(null)

    useEffect(() => {
        if (props.isUploadDoc === true) {
            $("#app-body").addClass("modal-open");
            $("#app-body").append('<div class="modal-backdrop fade show"></div>');
        }
        else {
            $("#app-body").removeClass("modal-open");
            $(".modal-backdrop").remove();
        }



    }, [props.isUploadDoc])


    useEffect(() => {
        if (uploadClaimDoc !== null) {
            dispatch(resetUploadClaimResponse())
            if (uploadClaimDoc.result === true) {
                toast.success(uploadClaimDoc.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
                $("#app-body").removeClass("modal-open");
                $(".modal-backdrop").remove();
                setValue('documents', null)
                props.isUploadDocClose()
                window.location.reload()

            } else {
                props.isUploadDocClose()
                switch (uploadClaimDoc.status_code) {

                }
            }
        }
    }, [uploadClaimDoc])




    const onSubmit = async (data) => {
        var input = {
            claim_id: props.intimateclaimObj.claim_id,
        }

        var files = [];
        if (data.documents != null) {
            files.push({
                name: "documents",
                value: data.documents[0],
            });
        }
        dispatch(actionUploadClaimDoc({ input, files }))


    };

    return (
        <>
            <div
                className="modal fade show"
                id="uploadDocument"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ display: props.isUploadDoc === true ? 'block' : 'none' }}

            >
                <div className="modal-dialog modal-dialog-centered">
                    <form
                        noValidate
                        autoComplete="off"
                        onSubmit={handleSubmit(
                            onSubmit
                        )}
                    >
                        <div className="modal-content">
                            <div className="modal-body ">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Upload Documents</h5>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                                props.isUploadDocClose()
                                                $("#app-body").removeClass("modal-open");
                                                $(".modal-backdrop").remove();
                                                setValue('documents', null)
                                            }}
                                        >
                                            <i className="fa fa-close" />

                                        </button>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="formFile" className="form-label">
                                            Attachment<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            accept=".gif,.png,.jpg,.doc,.docx,.pdf,.xlsx,.csv,.xls"

                                            {...register("documents", {
                                                required: "This is required.",
                                                validate: {
                                                    lessThan10MB: (files) => files[0]?.size < 5242880 || "Max size for image 5MB",
                                                    // acceptedFormats: (files) =>
                                                    //     ["image/jpg", "image/png", "image/gif"].includes(
                                                    //         files[0]?.type
                                                    //     ) || "only gif, png,jpg,doc,docx,pdf,xlsx,csv,xls images allowed."
                                                }
                                            })}
                                        />
                                        {errors.documents && (
                                            <ErrorLabel
                                                message={
                                                    errors
                                                        .documents
                                                        ?.message
                                                }
                                            />
                                        )}
                                    </div>
                                    <div className="col-12 mt-3">
                                        <small className="fs-7">
                                            *only gif, png,jpg,doc,docx,pdf,xlsx,csv,xls images allowed. Max
                                            size for image 5MB
                                        </small>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-sm  mt-3">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </>
    )

}

export default UploadDocuments;